import * as React from 'react'
import FormGroup from 'reactstrap/lib/FormGroup'
import Label from 'reactstrap/lib/Label'
import Input from 'reactstrap/lib/Input'
import AlertControlStats from './AlertControlStats'

const AlertControlSubHeader = ({ filterText, onSearch, onStatusModalToggle }) => {
  return (
    <div className="alert-control-center__sub-header">
      <div className="alert-filters">
        <span className="fa fa-sliders" aria-hidden="true" onClick={onStatusModalToggle}/>
        <FormGroup className="search-bar">
          <Label for="alert-search">Search</Label>
          <Input
            id="alert-search"
            type="search"
            name="search"
            placeholder="Find an alert by its ID"
            value={filterText}
            onChange={(e) => onSearch(e.target.value)}
          />
        </FormGroup>
      </div>
      <AlertControlStats />
    </div>
  )
}

export default React.memo(AlertControlSubHeader);



// WEBPACK FOOTER //
// ./src/modules/Alert/ControlCenter/components/AlertControlSubHeader.tsx